export function composeValidators<T>(...validators: ((val: T) => string | undefined)[]) {
  return (value: T): string | undefined => {
    for (const validator of validators) {
      const error = validator(value);
      if (error) {
        return error;
      }
    }

    return undefined;
  };
}
